import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { createPopper } from "@popperjs/core"

export default class extends Controller {
  static targets = ["selector", "button"]
  static values = { selection: String }

  connect() {
    this.tomselect = new TomSelect(this.selectorTarget, {
      dropdownParent: 'body',
      render: {
        item: (data, escape) => {
          return this.optionItem(data, escape)
        },
        option: (data, escape) => {
          return this.optionItem(data, escape, true)
        }
      },
      onChange: (value) => {
        if (value) {
          this.selectionValue = value
        }
        this.buttonTarget.disabled = false
      }
    })

    this.setupPopper()
    window.addEventListener("beforeunload", this.beforeUnload.bind(this))
  }

  disconnect() {
    this.beforeUnload()
  }

  beforeUnload() {
    if (this.popper) {
      this.popper.destroy()
      this.popper = null
    }
    if (this.tomselect) {
      this.tomselect.clear()
      this.tomselect.destroy()
      this.tomselect = null
    }
  }

  setupPopper() {
    this.popper = createPopper(this.tomselect.control, this.tomselect.dropdown, {
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -1],
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top-start'],
            rootBoundary: 'viewport',
          },
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport',
          },
        },
        {
          name: 'sameWidth',
          enabled: true,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn: ({ state }) => {
            state.styles.popper.width = `${state.rects.reference.width}px`
          },
          effect: ({ state }) => {
            state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`
          },
        },
      ],
    })

    // Set z-index on dropdown
    this.tomselect.dropdown.style.zIndex = '100'

    this.tomselect.on('dropdown_open', () => {
      if (this.popper) {
        this.popper.update()
      }
    })
  }

  optionItem(data, escape, isResult = false) {
    if (!data.value) {
      return isResult ? null : `<span class="text-black/30 text-base">Select a storefront</span>`
    }

    // Get data from the original option element
    const optionEl = this.selectorTarget.querySelector(`option[value="${data.value}"]`)
    const icon = optionEl?.dataset?.icon || ''
    const bg = optionEl?.dataset?.bg || '#ccc'

    return `
      <div class="flex items-center">
        <span class="flex items-center justify-center mr-2 w-8 h-8 rounded-full overflow-hidden"
          style="background-color: ${escape(bg)};"
        >
          <img class="max-w-full max-h-full" src="${escape(icon)}" />
        </span>
        ${escape(data.text)}
      </div>
    `
  }

  go() {
    if (this.selectionValue) {
      window.location.href = this.selectionValue
    }
  }
}
